<template>
  <div :class="$style.container">
    <p
      v-text-align:center
      v-word-break:break-word
      v-text="rating.question"
    ></p>

    <div :class="$style.content">
      <template
        v-for="value in maxValue"
      >
        <div
          :key="value"
          :class="[
            $style.grade,
            {
              [$style[type]]: true,
              [$style.hovered]: isHovered(value),
              [$style.selected]: isSelected(value),
            },
          ]"
          @click="handleSelect(value)"
          @mouseenter="handleHover(value)"
          @mouseleave="handleLeave"
        >
          <base-icon
            :name="isFilledIcon(value) ? `basic_${type}-filled` : `basic_${type}`"
            :size="48"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BaseIcon from 'atoms/base/BaseIcon';

export default {
  name: 'GradeManagement',
  components: {
    BaseIcon,
  },
  props: {
    rating: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxValue: 5,
      hoveredValue: null,
      selectedValue: null,
    };
  },
  computed: {
    type() {
      return this.rating.type;
    },
  },
  methods: {
    isHovered(value) {
      if (this.$validate.isNull(this.hoveredValue)) {
        return false;
      }

      return value <= this.hoveredValue;
    },
    isSelected(value) {
      if (this.$validate.isNull(this.hoveredValue)) {
        return value <= this.selectedValue;
      }

      return this.isHovered(value);
    },
    isFilledIcon(value) {
      return value <= this.selectedValue;
    },
    handleHover(value) {
      this.hoveredValue = value;
    },
    handleLeave() {
      this.hoveredValue = null;
    },
    handleSelect(value) {
      this.selectedValue = value;
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type('regular', 14, 20)
    padding: 20px
    color: #212121
    background-color: #fff
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 5px

  .content
    display: grid
    grid: 1fr / 1fr 1fr 1fr 1fr 1fr
    grid-gap: 10px
    padding: 10px

  .grade
    +flexbox
    +justify-content(center)
    color: #C5C5C8
    cursor: pointer

    &.star
      &.hovered,
      &.selected
        color: #FFC700

    &.heart
      &.hovered,
      &.selected
        color: #FF5172
</style>
